<!-- src/components/Home.vue -->

<template>
  <div>
    <header-component />
    <serviceBanner-component />
    <schduleAppointment-component />
    <footer-component />
  </div>
</template>

<script>
import headerComponent from '../header/headerComponent.vue';
import serviceBannerComponent from '../service/serviceBannerComponent.vue';
import schduleAppointmentComponent from '../service/schduleAppointmentComponent.vue';
import footerComponent from '../footer/footerComponent.vue';

export default {
  name: 'homeComponent',
  components: {
    headerComponent,
    serviceBannerComponent,
    schduleAppointmentComponent,
    footerComponent,
  },
};
</script>
